import Item from 'semantic-ui-react/dist/commonjs/views/Item';
import '@purple/semantic-ui-purple-theme/components/item.css';

export default Item;
